import type { Component } from 'vue';
import type { PermissionAreaType, PermissionFlagType } from '@/types/permissions';
import type { RoutePermissionCheck } from '@/types/vue-router';
import type { RouteRecordRaw } from 'vue-router';

export function permit(area: PermissionAreaType, flag: PermissionFlagType): RoutePermissionCheck[] {
    return [{ area, flag }];
}

export function redirectRoute(path: string, redirect: string): RouteRecordRaw {
    return { path, redirect } as RouteRecordRaw;
}

export function publicRoute(route: RouteRecordRaw): RouteRecordRaw;
export function publicRoute(path: string, component: Component): RouteRecordRaw;
export function publicRoute(
    pathOrRoute: string | RouteRecordRaw,
    component?: Component
): RouteRecordRaw {
    const route =
        typeof pathOrRoute === 'string'
            ? { path: pathOrRoute, component: component! }
            : pathOrRoute;
    return { ...route, meta: { ...route.meta, public: true } } as RouteRecordRaw;
}

export function roleRoute(route: RouteRecordRaw, role: string): RouteRecordRaw;
export function roleRoute(path: string, component: Component, role: string): RouteRecordRaw;
export function roleRoute(
    pathOrRoute: string | RouteRecordRaw,
    componentOrRole: Component | string,
    role?: string
): RouteRecordRaw {
    if (typeof pathOrRoute === 'string') {
        return {
            path: pathOrRoute,
            component: componentOrRole as Component,
            meta: { requiresRole: role! },
        } as RouteRecordRaw;
    }
    return {
        ...pathOrRoute,
        meta: { ...pathOrRoute.meta, requiresRole: componentOrRole as string },
    } as RouteRecordRaw;
}

export function openRoute(route: RouteRecordRaw): RouteRecordRaw;
export function openRoute(path: string, component: Component): RouteRecordRaw;
export function openRoute(
    pathOrRoute: string | RouteRecordRaw,
    component?: Component
): RouteRecordRaw {
    const route =
        typeof pathOrRoute === 'string'
            ? { path: pathOrRoute, component: component! }
            : pathOrRoute;
    return { ...route, meta: { ...route.meta, open: true } } as RouteRecordRaw;
}

export function protectedRoute(
    route: RouteRecordRaw,
    permissions: RoutePermissionCheck[]
): RouteRecordRaw;
export function protectedRoute(
    path: string,
    component: Component,
    permissions: RoutePermissionCheck[]
): RouteRecordRaw;
export function protectedRoute(
    pathOrRoute: string | RouteRecordRaw,
    componentOrPermissions: Component | RoutePermissionCheck[],
    permissions?: RoutePermissionCheck[]
): RouteRecordRaw {
    if (typeof pathOrRoute === 'string') {
        return {
            path: pathOrRoute,
            component: componentOrPermissions as Component,
            meta: { permissions: permissions! },
        } as RouteRecordRaw;
    }
    return {
        ...pathOrRoute,
        meta: {
            ...pathOrRoute.meta,
            permissions: componentOrPermissions as RoutePermissionCheck[],
        },
    } as RouteRecordRaw;
}
